// extracted by mini-css-extract-plugin
module.exports = {"wrapperNotFound":"styles_wrapperNotFound__dOtzb","wrapper":"styles_wrapper__YxNpo","quickBox":"styles_quickBox__6ICxo","box":"styles_box__0jaOV","text":"styles_text__IZyq0","title":"styles_title___VlXZ"};
module.exports.__checksum = "30092bbe177b"
